// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf, arrayOf } from "@altostra/type-validations";
import { nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

export const isEngagementCanvasLlmStepPreviewResult = objectOf({
  result: anyOf(string, nullOrUndefined),
  execution_time_ms: number,
  errors: anyOf(arrayOf(string), nullOrUndefined),
});
